// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1tK7s","boxTitle":"Qualiphy_boxTitle__2ygRO","box":"Qualiphy_box__3lDhn","toggleWrap":"Qualiphy_toggleWrap__2xvkR"};